export enum OnboardingDocumentMasterType {
  finOb1 = 1,
  finOb2 = 2,
  finOb3 = 3,
  finOb4 = 4,
  finOb5 = 5,
  finOb6 = 6,
  finOb7 = 7,
  finOb8 = 8,
  finOb9 = 9,
  finOb10 = 10,
  finOb11 = 11,
  lglOb1 = 12,
  lglOb2 = 13,
  lglOb3 = 14,
  lglOb4 = 15,
  lglOb5 = 16,
  lglOb6 = 17,
  lglOb7 = 18,
}

export const OnboardingDocumentMasterTypeText: Record<
  OnboardingDocumentMasterType,
  string
> = {
  [OnboardingDocumentMasterType.finOb1]: "FIN OB 1",
  [OnboardingDocumentMasterType.finOb2]: "FIN OB 2",
  [OnboardingDocumentMasterType.finOb3]: "FIN OB 3",
  [OnboardingDocumentMasterType.finOb4]: "FIN OB 4",
  [OnboardingDocumentMasterType.finOb5]: "FIN OB 5",
  [OnboardingDocumentMasterType.finOb6]: "FIN OB 6",
  [OnboardingDocumentMasterType.finOb7]: "FIN OB 7",
  [OnboardingDocumentMasterType.finOb8]: "FIN OB 8",
  [OnboardingDocumentMasterType.finOb9]: "FIN OB 9",
  [OnboardingDocumentMasterType.finOb10]: "FIN OB 10",
  [OnboardingDocumentMasterType.finOb11]: "FIN OB 11",
  [OnboardingDocumentMasterType.lglOb1]: "LGL OB 1",
  [OnboardingDocumentMasterType.lglOb2]: "LGL OB 2",
  [OnboardingDocumentMasterType.lglOb3]: "LGL OB 3",
  [OnboardingDocumentMasterType.lglOb4]: "LGL OB 4",
  [OnboardingDocumentMasterType.lglOb5]: "LGL OB 5",
  [OnboardingDocumentMasterType.lglOb6]: "LGL OB 6",
  [OnboardingDocumentMasterType.lglOb7]: "LGL OB 7",
};
